import { render, staticRenderFns } from "./addItemToSuggestionsListForm.vue.html?vue&type=template&id=db9d899a&"
import script from "./addItemToSuggestionsListForm.ts?vue&type=script&lang=ts&"
export * from "./addItemToSuggestionsListForm.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports